export const isSafariBrowser = () => {
    const ua = navigator.userAgent;

    // Need the negative check because many browsers on Apple devices (and even some on
    // Windows/Linux) include "Safari" in their UA string even when they’re not actually
    // Safari. Example:
    //   - Chrome on macOS: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/... (KHTML, like Gecko) Chrome/119.0 Safari/537.36
    //       → contains "Safari", but it’s Chrome.
    // Apple requires all browsers on iOS to use WebKit, so the UA string always contains "Safari" even if the browser is Edge/Chrome/Firefox.
    return /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Edg/i.test(ua);
};
